import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetGuestsiteTravelListQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  isAdminDashboard?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type GetGuestsiteTravelListQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    featureFlags?: Array<string | null> | null;
    travelSettings?: {
      __typename?: 'TravelSettings';
      carRentalEnabled?: boolean | null;
      venueAirport?: { __typename?: 'VenueAirport'; googlePlaceId: string; name: string; formattedAddress: string; latitude: number; longitude: number } | null;
    } | null;
    hotelRoomBlocks?: { __typename?: 'HotelRoomBlocks'; id: string; submittedDateTime?: any | null } | null;
    info: {
      __typename?: 'EventInfo';
      id: string;
      travel: Array<
        | {
            __typename?: 'EventTravelBookingType';
            address?: string | null;
            bookingType?: string | null;
            timezone?: string | null;
            latitude?: number | null;
            longitude?: number | null;
            placeId?: string | null;
            id: string;
            type: Types.TravelType;
            name: string;
            startTime?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number; hostTimeString: string; hostDateString: string } | null;
            endTime?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number; hostTimeString: string; hostDateString: string } | null;
          }
        | {
            __typename?: 'EventTravelList';
            id: string;
            type: Types.TravelType;
            name: string;
            items: Array<{ __typename?: 'EventTravelListItem'; id: string; title?: string | null; url?: string | null }>;
          }
        | { __typename?: 'EventTravelNote'; notes?: string | null; url?: string | null; id: string; type: Types.TravelType; name: string }
        | { __typename?: 'Ferry'; address?: string | null; telephone?: string | null; notes?: string | null; url?: string | null; id: string; type: Types.TravelType; name: string }
        | { __typename?: 'Flight'; url?: string | null; code?: string | null; notes?: string | null; id: string; type: Types.TravelType; name: string }
        | { __typename?: 'Hotel'; address?: string | null; telephone?: string | null; notes?: string | null; url?: string | null; id: string; type: Types.TravelType; name: string }
        | {
            __typename?: 'RentalCar';
            address?: string | null;
            telephone?: string | null;
            notes?: string | null;
            url?: string | null;
            id: string;
            type: Types.TravelType;
            name: string;
          }
        | {
            __typename?: 'RentalHome';
            address?: string | null;
            telephone?: string | null;
            notes?: string | null;
            url?: string | null;
            id: string;
            type: Types.TravelType;
            name: string;
          }
        | {
            __typename?: 'Shuttle';
            id: string;
            type: Types.TravelType;
            name: string;
            notes?: string | null;
            items: Array<{
              __typename?: 'ShuttleItem';
              id: string;
              note?: string | null;
              timezone?: string | null;
              url?: string | null;
              startTime?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number; hostTimeString: string; hostDateString: string } | null;
              endTime?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number; hostTimeString: string; hostDateString: string } | null;
            }>;
          }
        | { __typename?: 'Taxi'; address?: string | null; telephone?: string | null; notes?: string | null; url?: string | null; id: string; type: Types.TravelType; name: string }
        | { __typename?: 'Tent'; address?: string | null; telephone?: string | null; notes?: string | null; url?: string | null; id: string; type: Types.TravelType; name: string }
        | { __typename?: 'Train'; address?: string | null; telephone?: string | null; notes?: string | null; url?: string | null; id: string; type: Types.TravelType; name: string }
      >;
    };
  } | null;
};

export const GetGuestsiteTravelListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetGuestsiteTravelList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isAdminDashboard' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'carRentalEnabled' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'venueAirport' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'formattedAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hotelRoomBlocks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'submittedDateTime' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isAdminDashboard' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'travel' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravel' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventTravel' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventTravel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventTravelBookingType' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelBookingType' } }] },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventTravelNote' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelNote' } }] },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventTravelList' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelList' } }] },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Flight' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Flight' } }] },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RentalCar' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RentalCar' } }] },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Taxi' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Taxi' } }] },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Train' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Train' } }] },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Ferry' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Ferry' } }] },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Shuttle' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Shuttle' } }] },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Hotel' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Hotel' } }] },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Tent' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Tent' } }] },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RentalHome' } },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RentalHome' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventTravelBookingType' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventTravelBookingType' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bookingType' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'startTime' },
            name: { kind: 'Name', value: 'startTimeV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimezoneDate' } }] },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'endTime' },
            name: { kind: 'Name', value: 'endTimeV0918' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimezoneDate' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventTravelShared' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventTravelShared' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TimezoneDate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'hostTimeString' },
            name: { kind: 'Name', value: 'dateString' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'timeFormat' }, value: { kind: 'EnumValue', value: 'time' } }],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'hostDateString' },
            name: { kind: 'Name', value: 'dateString' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'dateFormat' }, value: { kind: 'EnumValue', value: 'full' } }],
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventTravelNote' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventTravelNote' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventTravelList' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventTravelList' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelShared' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelListItem' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventTravelListItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventTravelListItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Flight' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Flight' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RentalCar' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RentalCar' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Taxi' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Taxi' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Train' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Train' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Ferry' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Ferry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Shuttle' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Shuttle' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'startTime' },
                  name: { kind: 'Name', value: 'startTimeV0918' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimezoneDate' } }] },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'endTime' },
                  name: { kind: 'Name', value: 'endTimeV0918' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TimezoneDate' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Hotel' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Hotel' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Tent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Tent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RentalHome' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RentalHome' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventTravelShared' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'telephone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetGuestsiteTravelListQuery__
 *
 * To run a query within a React component, call `useGetGuestsiteTravelListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsiteTravelListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsiteTravelListQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *   },
 * });
 */
export function useGetGuestsiteTravelListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestsiteTravelListQuery, GetGuestsiteTravelListQueryVariables>) {
  return ApolloReactHooks.useQuery<GetGuestsiteTravelListQuery, GetGuestsiteTravelListQueryVariables>(GetGuestsiteTravelListDocument, baseOptions);
}
export function useGetGuestsiteTravelListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestsiteTravelListQuery, GetGuestsiteTravelListQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetGuestsiteTravelListQuery, GetGuestsiteTravelListQueryVariables>(GetGuestsiteTravelListDocument, baseOptions);
}
export type GetGuestsiteTravelListQueryHookResult = ReturnType<typeof useGetGuestsiteTravelListQuery>;
export type GetGuestsiteTravelListLazyQueryHookResult = ReturnType<typeof useGetGuestsiteTravelListLazyQuery>;
export type GetGuestsiteTravelListQueryResult = Apollo.QueryResult<GetGuestsiteTravelListQuery, GetGuestsiteTravelListQueryVariables>;
